import { getBasePath } from "@/config/runtimeConfig";

export const COOKIE_SETTINGS = {
  path: getBasePath(), // Important for SPA
  maxAge: 365 * 86400, // 1 Day = 24 Hrs = 24*60*60 = 86400.
};
